import lodash from 'lodash';
import { internalInstitutionIdsSelector, monitorInstitutionIdsSelector } from 'common/features/selectors';

import {
    STUDIES_WRITE,
    STUDIES_UNLOAD,
    STUDY_STAGES_WRITE
} from 'overview/actions/studies';

export function studiesOverviewReducer(state, action) {
    if (action && action.type !== STUDIES_WRITE) {
        return state;
    }
    const currentOffset = lodash.get(state, 'studies.offset', 0);
    const existingStudies = lodash.get(state, 'studies.studies', []);
    const studiesPayload = action.payload.studies || [];
    const nextStudies = studiesPayload.map(study => ({ ...study, binderPermissions: JSON.parse(study.binderPermissions) }));
    const filteredStudies = institutionFilter(nextStudies, state);

    return {
        ...state,
        studies: {
            studies: existingStudies.concat(filteredStudies),
            isLoading: action.payload.isLoading,
            hasMoreStudies: nextStudies.length > 0,
            offset: currentOffset + nextStudies.length,
        },
    };
}

function institutionFilter(existingStudies, state) {
    const monitorInstIds = monitorInstitutionIdsSelector(state);
    const internalInstIds = internalInstitutionIdsSelector(state);
    const institutionIds = lodash.union(monitorInstIds, internalInstIds);

    return existingStudies.filter(study => institutionIds.includes(study.institutionId));
}


export function unloadStudiesOverviewReducer(state, action) {
    if (!action || action.type !== STUDIES_UNLOAD) {
        return state;
    }

    return setDefaultState(state);
}

function setDefaultState(state) {

    return { ...state, studies: { studies: [], isLoading: true, hasMoreStudies: false, offset: 0 } };
}

export function loadStudyStagesReducer(state, action) {
    if (!action || action.type !== STUDY_STAGES_WRITE) {
        return state;
    }

    return {
        ...state,
        studyStages: action.payload
    };
}
